/* NORVANE V13 - Transparent at the top, fully solid after scroll.
   Safe on page navigation and in Shopify Theme Editor section reloads. */
(() => {
  if (window.__norvaneTransparentHeaderBound) return;
  window.__norvaneTransparentHeaderBound = true;

  let frame = 0;
  let observedHeader = null;
  const menuObserver = new MutationObserver(schedule);

  // The menu component opens its dropdown on pointerenter/focus and toggles
  // aria-expanded. Treat an OPEN dropdown like the scrolled header while
  // keeping the actual scroll position independent.
  function hasOpenSubmenu(header) {
    const dropdownLinks = header.querySelectorAll('header-menu .menu-list__link[aria-haspopup="true"]');
    for (const link of dropdownLinks) {
      if (link.getAttribute('aria-expanded') === 'true' || link.matches(':hover') || link.matches(':focus-visible')) {
        return true;
      }
    }
    return false;
  }

  function watchMenu(header) {
    if (observedHeader === header) return;
    menuObserver.disconnect();
    observedHeader = header;
    if (header) {
      menuObserver.observe(header, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-expanded']
      });
    }
  }

  function refresh() {
    const header = document.querySelector('#header-component[data-norvane-scroll-header]');
    watchMenu(header);
    if (!header) return;
    const threshold = Math.max(0, Number(header.dataset.norvaneScrollThreshold) || 0);
    const scrollTop = Math.max(0, window.scrollY || document.scrollingElement?.scrollTop || 0);
    const menuOpen = hasOpenSubmenu(header);
    // Treat hovering the header (including the mega menu underneath it) just
    // like scrolling: same background, text, icons and cart count palette.
    // Restrict hover to real pointers, so taps on mobile don't leave it stuck.
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const hovered = canHover && header.matches(':hover');
    const focused = header.matches(':focus-within');
    const next = scrollTop > threshold || hovered || menuOpen || focused ? 'true' : 'false';
    if (header.dataset.norvaneScrolled !== next) {
      header.dataset.norvaneScrolled = next;
    }
  }

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      refresh();
    });
  }

  // Hover can start before aria-expanded is updated by the native theme menu.
  // Tracking both pointer and focus ensures correct mouse and keyboard states.
  for (const eventName of ['pointerover', 'pointerout', 'focusin', 'focusout']) {
    document.addEventListener(eventName, event => {
      if (event.target?.closest?.('#header-component[data-norvane-scroll-header]')) schedule();
    }, true);
  }
  document.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
})();
